"use client";

import {usePathname} from "next/navigation";
import {useGailDock} from "@/contexts/chat/GailDockContext";
import {useGailGptChatAccess} from "@/hooks/useGailGptChatAccess";
import {shouldShowGailGptLauncher} from "@/utils/chat/gailGptLauncher";
import GailCornerLauncher from "./GailCornerLauncher";
import GailTopbarLauncher from "./GailTopbarLauncher";
import GailExistingChatEntry from "./GailExistingChatEntry";

/** Select an entry for the available chat surface and shell placement. */
export default function GailGptLauncher({placement = "corner"}: {placement?: "corner" | "topbar"}) {
  const pathname = usePathname() ?? "";
  const {allowed} = useGailGptChatAccess();
  const {isDockAvailable} = useGailDock();
  if (!allowed) return null;
  if (!shouldShowGailGptLauncher(pathname, allowed, isDockAvailable)) {
    return placement === "topbar" ? <GailExistingChatEntry /> : null;
  }
  return placement === "topbar" ? <GailTopbarLauncher /> : <GailCornerLauncher />;
}
